import classes from "./EntityBenefitMark.module.css";
import { t } from "i18next";

const EntityBenefitMark = () => {
  return <div className={classes.benefitItemMark}>{t("benefit")}</div>;
};

export default EntityBenefitMark;
